import { Input } from '@builder.io/sdk';

import { moleculeHeadingFields } from 'molecules/Heading/config';
import sectionFields from 'molecules/Section/config';

import imageCardFields from 'organisms/Cards/ImageCard/config';

const imageCardDeckFields = [
  ...moleculeHeadingFields,
  {
    name: 'cards',
    type: 'list',
    subFields: imageCardFields,
    helperText: 'Add up to 6 Image Cards. Cards beyond the limit will be removed automatically.',
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onChange: (options: Map<string, any>) => {
      if (options.get('cards').length > 6) {
        options.set('cards', options.get('cards').slice(0, 6));
        alert('Maximum card count is 6. Removing excess cards.');
      }
    },
  },
  ...sectionFields,
] as const satisfies DeepReadonly<Input[]>;

const imageCardDeckConfig = {
  name: 'ImageCardDeck',
  inputs: imageCardDeckFields,
};

export type ImageCardDeckConfig = GenerateBuilder<typeof imageCardDeckFields>;

export default imageCardDeckConfig;
